import React from 'react';

function SvgArrowLeftNarrow(props) {
  return (
    <svg
      width="62"
      height="11"
      viewBox="0 0 62 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.97451 9.9158C8.17573 9.88969 8.33503 9.78217 8.39162 9.64085C8.44822 9.49646 8.38953 9.3444 8.24281 9.24302L3.34225 5.65178H19.0919C19.1087 5.65178 60.041 5.66099 60.0578 5.66099C60.3512 5.65178 60.5818 5.46745 60.5671 5.25241C60.5524 5.03736 60.303 4.86994 60.0075 4.88069L3.34225 4.87147L8.24281 1.28023C8.40002 1.185 8.47337 1.03446 8.42726 0.887006C8.38115 0.742619 8.22604 0.627417 8.02692 0.593624C7.8278 0.559832 7.62028 0.613592 7.49242 0.73033L1.6759 4.98053L1.3091 5.26162L1.6759 5.54272L7.49242 9.79292C7.60351 9.88047 7.76281 9.92502 7.9263 9.9158C7.94307 9.9158 7.95774 9.9158 7.97451 9.9158Z"
        fill={props.color || 'black'}
        stroke={props.color || 'black'}
      />
    </svg>
  );
}

export default SvgArrowLeftNarrow;
